import * as React from "react";

function SvgNatero(props, ref) {
  return (
    <svg
      id="Natero_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 60.4 60.6"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Natero_svg__st0{fill:#005594}.Natero_svg__st1{fill:#2ec3ff}"}
      </style>
      <path
        className="Natero_svg__st0"
        d="M44.5 34.1l15.8-12.7c-.7-2.2-1.5-4.4-2.7-6.4l-5.4-.5-.3-.5c-1.6-2.1-3.4-4-5.5-5.5l-.5-.4-.4-5.4C43.4 1.5 41.2.6 38.9 0l-4.1 3.5-.6-.1c-2.1-.3-4.3-.4-6.4-.1l13.5 16.9c2.5 2.7 3.9 6.3 3.9 10-.1 1.3-.3 2.6-.7 3.9"
      />
      <path
        className="Natero_svg__st1"
        d="M20.9 18.6c.3-.2.6-.5.9-.7l.3-.2c.3-.2.6-.4 1-.6l.2-.1c.4-.2.7-.4 1.1-.5l.2-.1c.4-.2.8-.3 1.2-.4l.2-.1 1.2-.3h.2c.5-.1.9-.2 1.4-.2h.1c1.1-.1 1.9-.1 2.9 0 .2 0 .4 0 .5.1l.4.1c.2 0 .4 0 .5.1.3.1.6.1.9.2h.1L21.5 0c-.5.1-.9.3-1.4.4-.7.2-1.3.5-2 .8-1.1.5-2.2 1-3.2 1.5l-.5 5.4-.4.4c-2.1 1.6-4 3.4-5.5 5.5l-.4.5-5.4.5c-.3.6-.7 1.3-1.1 2.1-.7 1.5-1.2 3-1.7 4.4l3.5 4.1-.1.6c-.2 1.3-.3 2.6-.3 3.9 0 .9 0 1.8.1 2.7l17-13.8.3-.3c.3.1.4 0 .5-.1M28.8 16.8zM37.8 43c-3.5 2.1-7.8 2.6-11.7 1.5L39 60.6c2.2-.7 4.4-1.6 6.4-2.7l.4-5.4.5-.4c2.1-1.6 4-3.4 5.5-5.5l.4-.5 5.4-.4c1.2-2.1 2.1-4.3 2.7-6.6v-.3l-3.5-4.1.1-.6c.2-1.3.3-2.5.3-3.7V30.1c0-.9 0-1.8-.1-2.7L40.7 40.7c-.7.7-1.5 1.4-2.5 2l-.4.3z"
      />
      <path
        className="Natero_svg__st0"
        d="M2.7 45.4l5.4.4.4.5c1.6 2.1 3.4 4 5.5 5.5l.5.4.5 5.4c2.1 1.2 4.3 2.1 6.6 2.7l4.1-3.5.6.1c2.1.3 4.3.4 6.4.2L18 38.7c-1.7-2.5-2.7-5.4-2.7-8.4 0-1.3.2-2.7.5-3.9L.1 39c.6 2.3 1.5 4.4 2.6 6.4"
      />
    </svg>
  );
}

export default React.forwardRef(SvgNatero);
